(function () {
  'use strict';

  function byId(id) { return document.getElementById(id); }
  function value(id) { var node = byId(id); return node ? node.value : ''; }
  function numberValue(id) { return parseFloat(value(id)) || 0; }
  function dispatchChange(node) { if (node) node.dispatchEvent(new Event('change', { bubbles: true })); }

  function moveNode(selector, targetName) {
    var node = document.querySelector(selector);
    var target = document.querySelector('[data-mep-target="' + targetName + '"]');
    if (node && target) target.appendChild(node);
    return node;
  }

  function activePathway() {
    var checked = document.querySelector('input[name="mep-pathway"]:checked');
    if (checked) return checked.value;
    var active = document.querySelector('.ic-mode-btn.active');
    return active ? active.getAttribute('data-mode') : 'predictive';
  }

  function activeCareSetting() {
    var checked = document.querySelector('input[name="mep-care-setting"]:checked');
    return checked ? checked.value : (value('ic-context') || 'ambulatory');
  }

  function requiredInputs() {
    var requirements = [
      { id: 'ic-sex', label: 'Equation sex coefficient', valid: function () { return value('ic-sex') !== ''; } },
      { id: 'ic-age', label: 'Age', valid: function () { var n = numberValue('ic-age'); return n >= 0.1 && n <= 120; } },
      { id: 'ic-weight', label: 'Current weight', valid: function () { var n = numberValue('ic-weight'); return n >= 1 && n <= 300; } },
      { id: 'ic-height', label: 'Height', valid: function () { var n = numberValue('ic-height'); return n >= 30 && n <= 250; } }
    ];
    var pathway = activePathway();
    if (activeCareSetting() === 'icu') {
      requirements.push({ id: 'ic-icu-phase', label: 'ICU feeding phase', valid: function () { return value('ic-icu-phase') !== ''; } });
    }
    if (pathway === 'full-ic') {
      requirements.push({ id: 'ic-vo2', label: 'Measured VO₂', valid: function () { return numberValue('ic-vo2') > 0; } });
      requirements.push({ id: 'ic-vco2-lmin', label: 'Measured VCO₂', valid: function () { return numberValue('ic-vco2-lmin') > 0; } });
    } else if (pathway === 'vco2-only') {
      requirements.push({ id: 'ic-vco2-mlmin', label: 'Ventilator VCO₂', valid: function () { return numberValue('ic-vco2-mlmin') > 0; } });
    } else if (pathway === 'vo2-only') {
      requirements.push({ id: 'ic-vo2-only', label: 'Measured VO₂', valid: function () { return numberValue('ic-vo2-only') > 0; } });
    }
    return requirements;
  }

  function setStepState(step, label, complete) {
    var node = document.querySelector('[data-mep-step="' + step + '"] [data-mep-step-state]');
    if (!node) return;
    node.textContent = label;
    node.classList.toggle('is-complete', !!complete);
  }

  function updateWorkflowState() {
    var requirements = requiredInputs();
    var missing = requirements.filter(function (item) { return !item.valid(); });
    var baseMissing = missing.filter(function (item) { return ['ic-sex', 'ic-age', 'ic-weight', 'ic-height'].indexOf(item.id) >= 0; });
    var measurementMissing = missing.filter(function (item) { return baseMissing.indexOf(item) < 0; });
    var hasWeightHistory = numberValue('mep-usual-weight') > 0 || numberValue('mep-weight-1m') > 0 || numberValue('mep-weight-3m') > 0 || numberValue('mep-weight-6m') > 0 || numberValue('ic-dry-weight') > 0 || numberValue('mep-post-dialysis-weight') > 0;
    var hasDelivery = Array.prototype.some.call(document.querySelectorAll('.mep-delivery-kcal,.mep-delivery-protein'), function (node) { return (parseFloat(node.value) || 0) > 0; });
    setStepState(1, baseMissing.length ? baseMissing.length + ' required' : 'Complete', baseMissing.length === 0);
    setStepState(2, hasWeightHistory ? 'Weights reviewed' : 'Add history if available', hasWeightHistory);
    setStepState(3, measurementMissing.length ? measurementMissing.length + ' required' : 'Pathway complete', measurementMissing.length === 0);
    setStepState(4, 'Review modifiers', false);
    setStepState(5, hasDelivery ? 'Delivery entered' : 'Optional', hasDelivery);
    setStepState(6, missing.length ? 'Not ready' : 'Ready to calculate', missing.length === 0);

    var state = byId('mep-readiness-state');
    var list = byId('mep-readiness-list');
    if (state) state.textContent = missing.length ? 'Assessment needs ' + missing.length + ' required input' + (missing.length === 1 ? '' : 's') : 'Assessment is ready to calculate';
    if (list) {
      list.innerHTML = missing.length
        ? missing.map(function (item) { return '<li><button type="button" data-mep-focus="' + item.id + '">' + item.label + '</button></li>'; }).join('')
        : '<li>Care setting and pathway selected</li><li>Required patient and measurement inputs complete</li><li>Dosing weights will be stated in the report</li>';
    }

    window.DietXP = window.DietXP || {};
    window.DietXP.MEP = window.DietXP.MEP || {};
    window.DietXP.MEP.workflowState = {
      careSetting: activeCareSetting(),
      pathway: activePathway(),
      complete: missing.length === 0,
      missing: missing.map(function (item) { return { id: item.id, label: item.label }; }),
      firstInvalidId: missing.length ? missing[0].id : null,
      steps: {
        patient: baseMissing.length === 0,
        weights: hasWeightHistory,
        measurement: measurementMissing.length === 0,
        delivery: hasDelivery
      }
    };
  }

  function focusField(id) {
    var node = byId(id);
    if (!node) return;
    var step = node.closest('.mep-workflow-step');
    (step || node).scrollIntoView({ behavior: 'auto', block: 'start' });
    window.setTimeout(function () { node.focus({ preventScroll: true }); }, 350);
  }

  function syncCareSetting(care) {
    var context = byId('ic-context');
    var activity = byId('ic-activity');
    var activityWrap = byId('activity-wrap');
    if (context) {
      context.value = care;
      dispatchChange(context);
    }
    if (activity) {
      if (care === 'inpatient') {
        if (activity.value !== 'inpatient_bedbound') activity.dataset.previousOutpatientValue = activity.value;
        activity.value = 'inpatient_bedbound';
        dispatchChange(activity);
      } else if (care === 'ambulatory' && activity.value === 'inpatient_bedbound') {
        activity.value = activity.dataset.previousOutpatientValue || 'moderate_global';
        dispatchChange(activity);
      }
    }
    if (activityWrap) activityWrap.hidden = care === 'icu';

    var phase = byId('ic-icu-phase');
    var phaseGroup = phase ? phase.closest('.ic-field-group') : null;
    var phaseRow = phaseGroup ? phaseGroup.parentElement : null;
    if (phaseGroup) phaseGroup.hidden = care !== 'icu';
    if (phaseRow) phaseRow.classList.toggle('mep-single-field', care !== 'icu');
    var measurementPanel = byId('tab-ic-data');
    if (measurementPanel) {
      Array.prototype.forEach.call(measurementPanel.querySelectorAll('.ic-section-title'), function (title) {
        if (title.textContent.indexOf('ICU Feeding Phase') >= 0 || title.dataset.mepPhaseTitle === 'true') {
          title.dataset.mepPhaseTitle = 'true';
          title.textContent = care === 'icu' ? 'ICU feeding phase and route' : 'Feeding route';
        }
      });
    }
    updateWorkflowState();
  }

  function syncPathway(pathway) {
    var modeButton = document.querySelector('.ic-mode-btn[data-mode="' + pathway + '"]');
    if (modeButton && !modeButton.classList.contains('active')) modeButton.click();
    var equationSelect = byId('ic-region');
    var equationGroup = equationSelect ? equationSelect.closest('.ic-field-group') : null;
    if (equationGroup) equationGroup.hidden = pathway !== 'predictive';
    Array.prototype.forEach.call(document.querySelectorAll('[data-mep-quality-for]'), function (node) {
      var allowed = (node.getAttribute('data-mep-quality-for') || '').split(/\s+/);
      node.hidden = allowed.indexOf(pathway) < 0;
    });
    syncAgeEquation();
    updateWorkflowState();
  }

  function syncAgeEquation() {
    var age = numberValue('ic-age');
    var equation = byId('ic-region');
    if (!equation) return;
    var pediatric = age > 0 && age < 18;
    Array.prototype.forEach.call(equation.options, function (option) {
      option.disabled = pediatric ? option.value !== 'pediatric' : option.value === 'pediatric';
    });
    if (pediatric && activePathway() === 'predictive') {
      if (equation.value !== 'pediatric') equation.dataset.previousAdultEquation = equation.value || 'global_mifflin';
      equation.value = 'pediatric';
      dispatchChange(equation);
    } else if (!pediatric && age >= 18 && equation.value === 'pediatric') {
      equation.value = equation.dataset.previousAdultEquation || 'global_mifflin';
      dispatchChange(equation);
    }
  }

  function addFieldStatuses() {
    var required = ['ic-sex', 'ic-age', 'ic-weight', 'ic-height'];
    var recommended = ['ic-region', 'mep-usual-weight', 'mep-weight-source', 'ic-protein-weight-basis'];
    var conditional = ['ic-activity', 'ic-icu-phase', 'ic-dry-weight', 'mep-post-dialysis-weight', 'ic-vo2', 'ic-vco2-lmin', 'ic-vco2-mlmin', 'ic-vo2-only', 'ic-rq', 'ic-rq-vo2only', 'ic-fio2-device-max'];
    Array.prototype.forEach.call(document.querySelectorAll('.ic-label[for]'), function (label) {
      if (label.querySelector('.mep-inline-status')) return;
      var target = label.getAttribute('for');
      var kind = required.indexOf(target) >= 0 ? 'Required' : recommended.indexOf(target) >= 0 ? 'Recommended' : conditional.indexOf(target) >= 0 ? 'Conditional' : 'Optional';
      var badge = document.createElement('span');
      badge.className = 'mep-inline-status is-' + kind.toLowerCase();
      badge.textContent = kind;
      label.appendChild(badge);
    });
  }

  function buildGuidedLayout() {
    var shell = byId('mep-guided-shell');
    var wrap = document.querySelector('.ic-wrap');
    if (!shell || !wrap) return;

    moveNode('#tab-demographics', 'patient');
    moveNode('#tab-body-comp', 'weights');
    moveNode('[data-mep-block="weight-trend"]', 'weights');
    moveNode('#tab-ic-data', 'measurement');
    moveNode('#tab-overlays', 'modifiers');
    moveNode('[data-mep-block="delivery"]', 'delivery');
    moveNode('[data-mep-block="protocols"]', 'protocols');
    moveNode('.ic-form-actions', 'actions');

    var patientIdField = document.querySelector('[data-mep-patient-id-field]');
    var reviewMetaField = document.querySelector('[data-mep-review-meta-field]');
    var refeedingField = document.querySelector('[data-mep-refeeding-field]');
    var patientTarget = document.querySelector('[data-mep-target="patient"]');
    var modifiersTarget = document.querySelector('[data-mep-target="modifiers"]');
    if (patientIdField && patientTarget) {
      patientIdField.classList.add('mep-patient-id-field');
      patientTarget.insertBefore(patientIdField, patientTarget.firstChild);
    }
    if (reviewMetaField && patientTarget) {
      reviewMetaField.classList.add('mep-review-meta-field');
      patientTarget.insertBefore(reviewMetaField, patientTarget.firstChild.nextSibling);
    }
    if (refeedingField && modifiersTarget) {
      refeedingField.classList.add('mep-refeeding-field');
      modifiersTarget.appendChild(refeedingField);
    }

    var hospitalPanel = byId('tab-hospital');
    if (hospitalPanel) hospitalPanel.remove();
    Array.prototype.forEach.call(document.querySelectorAll('.ic-tab-panel'), function (panel) {
      panel.classList.add('active');
      panel.removeAttribute('role');
      panel.setAttribute('aria-hidden', 'false');
    });

    var context = byId('ic-context');
    var contextGroup = context ? context.closest('.ic-field-group') : null;
    if (contextGroup) contextGroup.hidden = true;
    var modeSwitcher = document.querySelector('.ic-mode-switcher');
    if (modeSwitcher) {
      modeSwitcher.hidden = true;
      var preceding = modeSwitcher.previousElementSibling;
      if (preceding) { preceding.hidden = true; preceding = preceding.previousElementSibling; }
      if (preceding) preceding.hidden = true;
    }
    var measurementPanel = byId('tab-ic-data');
    if (measurementPanel) {
      Array.prototype.forEach.call(measurementPanel.children, function (child) {
        var copy = (child.textContent || '').trim();
        if (copy.indexOf('Choose Measurement Pathway') === 0 || copy.indexOf('Most users start with') === 0) child.hidden = true;
      });
    }

    shell.hidden = false;
    wrap.classList.add('mep-guided-ready');
    addFieldStatuses();

    Array.prototype.forEach.call(document.querySelectorAll('input[name="mep-care-setting"]'), function (radio) {
      radio.addEventListener('change', function () { if (this.checked) syncCareSetting(this.value); });
    });
    Array.prototype.forEach.call(document.querySelectorAll('input[name="mep-pathway"]'), function (radio) {
      radio.addEventListener('change', function () { if (this.checked) syncPathway(this.value); });
    });

    var formCard = document.querySelector('.ic-form-card');
    if (formCard) {
      formCard.addEventListener('input', updateWorkflowState);
      formCard.addEventListener('change', updateWorkflowState);
      formCard.addEventListener('click', function (event) {
        var focusButton = event.target.closest('[data-mep-focus]');
        if (focusButton) focusField(focusButton.getAttribute('data-mep-focus'));
      });
    }
    var ageInput = byId('ic-age');
    if (ageInput) {
      ageInput.addEventListener('input', function () { syncAgeEquation(); updateWorkflowState(); });
      ageInput.addEventListener('change', function () { syncAgeEquation(); updateWorkflowState(); });
    }

    var calc = byId('ic-calculate-btn');
    if (calc) calc.addEventListener('click', function () {
      window.setTimeout(function () {
        updateWorkflowState();
        var workflow = window.DietXP && window.DietXP.MEP && window.DietXP.MEP.workflowState;
        if (workflow && workflow.firstInvalidId) focusField(workflow.firstInvalidId);
      }, 20);
    });

    var reset = byId('ic-reset-btn');
    if (reset) reset.addEventListener('click', function () {
      wrap.classList.remove('mep-report-active');
      window.setTimeout(function () {
        var outpatient = document.querySelector('input[name="mep-care-setting"][value="ambulatory"]');
        var predictive = document.querySelector('input[name="mep-pathway"][value="predictive"]');
        if (outpatient) outpatient.checked = true;
        if (predictive) predictive.checked = true;
        syncCareSetting('ambulatory');
        syncPathway('predictive');
      }, 0);
    });

    document.addEventListener('dietxp:mep-result', function () {
      wrap.classList.add('mep-report-active');
      updateWorkflowState();
      window.setTimeout(function () {
        var report = byId('mep-full-report');
        if (report) report.scrollIntoView({ behavior: 'auto', block: 'start' });
        var heading = byId('mep-report-title');
        if (heading) { heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true }); }
      }, 80);
    });

    var edit = byId('mep-edit-assessment');
    if (edit) edit.addEventListener('click', function () {
      wrap.classList.remove('mep-report-active');
      var first = byId('mep-step-1');
      if (first) first.scrollIntoView({ behavior: 'auto', block: 'start' });
    });

    syncCareSetting(value('ic-context') === 'icu' ? 'icu' : value('ic-context') === 'inpatient' ? 'inpatient' : 'ambulatory');
    syncPathway(activePathway());
    updateWorkflowState();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', buildGuidedLayout);
  else buildGuidedLayout();
})();
